import { provideHttpClient } from '@angular/common/http';
import { NgModule } from "@angular/core";
import { BrowserModule, Title } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { SharedModule } from "./modules/shared/shared.module";
import { AppRoutingModule } from './routing/app-routing.module';
import { MissingTranslationHandler, MissingTranslationHandlerParams, provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { OAuthResultComponent } from './pages/oauth-result/oauth-result.component';
import { AutoLoginComponent } from "./pages/auto-login/auto-login.component";
import { AutoLoginMetricsComponent } from "./pages/auto-login-metrics/auto-login-metrics.component";
import { ShopifyOAuthResultComponent } from "./pages/shopify-oauth-result/shopify-oauth-result.component";
import { EcwidOauthResultComponent } from "./pages/ecwid-oauth-result/ecwid-oauth-result.component";
import { ScriptLoaderService } from "angular-google-charts";
import { MessageModule } from "./modules/shared/message/message.module";

export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    const interpolateParams: any = params.interpolateParams;
    if (interpolateParams?.fallbackText) {
      return interpolateParams.fallbackText;
    } else if (interpolateParams?.fallbackTranslation) {
      return params.translateService.get(interpolateParams.fallbackTranslation, interpolateParams);
    } else if (interpolateParams?.fallbackTranslationValue) {
      return interpolateParams?.fallbackTranslationValue;
    }
  }
}

@NgModule({
  declarations: [
    AppComponent,
    AutoLoginComponent,
    AutoLoginMetricsComponent,
    OAuthResultComponent,
    EcwidOauthResultComponent,
    ShopifyOAuthResultComponent
  ],
  imports: [
    SharedModule,
    MessageModule,
    BrowserModule,
    AppRoutingModule
  ],
  providers: [
    Title,
    ScriptLoaderService,
    provideHttpClient(),
    provideTranslateService({
      fallbackLang: "en",
      loader: provideTranslateHttpLoader({prefix: "./assets/i18n/", suffix: ".json"}),
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MyMissingTranslationHandler
      }
    })
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
